<div class="font-weight-bold mb-3">{{ field.description }}</div>

<button type="button" class="btn btn-success disabled sm-cursor-grab" i18n>Signature</button>

<div *ngIf="field.signatureRules?.length" class="signature-logic-container">
  <i class="cc-icon cc-icon-logic"></i>
  <span i18n class="logic-title">Approval Signature Logic</span>
</div>
